import { content_v1_DatasourcePresetVersionList } from '@antimatterhq/asl-api-ts-v1';
import { getUpgradePresetVersion } from '../../uiStatus';
import { Datasource } from '@/types/api';

export const getLatestPresetVersion = (
  presetVersions: content_v1_DatasourcePresetVersionList | undefined,
) => {
  if (!presetVersions) return undefined;
  return [...presetVersions.versions].sort(
    (a, b) => (b.versionNumber || 0) - (a.versionNumber || 0),
  )[0];
};

export type AvailablePresetVersion = {
  version: number | undefined;
  state: 'in-progress' | 'available' | 'up-to-date';
};

export const getAvailablePresetVersion = (
  datasource: Datasource | undefined,
  presetVersions: content_v1_DatasourcePresetVersionList | undefined,
): AvailablePresetVersion => {
  if (!datasource || !datasource.spec.usePresetVersion) {
    return {
      version: undefined,
      state: 'up-to-date',
    };
  }
  const inProgressVersion = getUpgradePresetVersion(datasource);
  if (inProgressVersion) {
    return {
      version: inProgressVersion,
      state: 'in-progress',
    };
  }
  const latestVersion = getLatestPresetVersion(presetVersions);

  if (
    !latestVersion?.versionNumber ||
    (datasource.spec.usePresetVersion &&
      latestVersion.versionNumber <= datasource.spec.usePresetVersion)
  ) {
    return {
      version: latestVersion?.versionNumber,
      state: 'up-to-date',
    };
  }

  return {
    version: latestVersion.versionNumber,
    state: 'available',
  };
};
